.bd{flex:1;}